module.exports = __webpack_public_path__ + "static/media/people_img.335e5e84.png";